import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';

import { fb } from '../../../../../modules/shared/shared.global-service';
import { isInvalid } from '../../../../../modules/shared/helpers/validate';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';
import { CurrencyGridObject, CurrencyObject } from '@libs/types/src/mado/object-type/currency/currency.object';
import { currencyMutationFrag } from './organization-settings-currency-dialog.query';
import { OrganizationSettingCurrencyDialogStore } from './organization-settings-currency-dialog.store';
import { CurrencyUpdateInput } from '@libs/types/src/mado/input-type/currency/currency.update-input';
import { CurrencyCreateInput } from '@libs/types/src/mado/input-type/currency/currency.create-input';
import { SwitchInputComponent } from '../../../../kit/input/switch-input/switch-input.component';

@Component({
    selector: 'app-organization-settings-currency-dialog',
    templateUrl: './organization-settings-currency-dialog.component.html',
    providers: [OrganizationSettingCurrencyDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextInputComponent,
        SwitchInputComponent,
    ]
})
export class OrganizationSettingsCurrencyDialogComponent extends BaseDialogComponent {
    protected readonly store = inject(OrganizationSettingCurrencyDialogStore);

    protected readonly translatePrefix = 'madoCurrency.';

    protected readonly data = this.dialogConfig.data.currency || null;
    protected readonly organizationId = this.dialogConfig.data.organizationId || null;

    currencyOptions = signal<CurrencyGridObject[]>([])

    protected form = fb.group({
        name: fb.control<string | null>(null, [Validators.required]),
        code: fb.control<string | null>(null, [Validators.required]),
        isDefault: fb.control<boolean | null>(null),
    })

    constructor() {
        super();

        // Patch on EDIT
        if (this.data) {
            this.patchForm(this.data);
        }
    }

    override async save() {
        if (isInvalid(this.form)) return;
        
        const _data = {
            name: this.form.value.name!,
            code: this.form.value.code!,
            isDefault: !!this.form.value.isDefault,
        }

        if (this.data) {
            // UPDATE
            const data = {
                ..._data,
                id: this.data.id,
            } as CurrencyUpdateInput

            await this.store.api.updateCurrency(data, currencyMutationFrag);
            

        } else {
            // CREATE
            if (!this.organizationId) return;
            const data = {
                ..._data,
                organizationId: Number(this.organizationId),
            } as CurrencyCreateInput

            await this.store.api.createCurrency(data, currencyMutationFrag);
        }

        this.dialogRef.close(true);
    }

    private patchForm(item: CurrencyObject) {
        this.form.patchValue({
            name: item?.name,
            code: item?.code,
            isDefault: item?.isDefault,
        })
    }
}
